import React, { useCallback, useEffect, useState } from "react";

import { useIntl } from "react-intl";

import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import ModError from "react-lib/appcon/common/ModInfo";

import ModAuthen from "react-lib/apps/common/ModAuthen";

type SubLabCareProviderProps = {
  setProp: (key: string, value: any) => void;
  runSequence: (e: any) => any;
  cardKey: string;
  item: Record<string, any>;
  selectedEmr?: Record<string, any>;
  buttonLoadCheck?: any;
  django?: any;
  errorMessage?: Record<string, any>;
  masterOptions?: Record<string, any>;
  successMessage?: Record<string, any>;
  onApprove: () => void;
};

const SubLabCareProvider: React.FC<SubLabCareProviderProps> = (props) => {
  const intl = useIntl();
  const [openModAuthen, setOpenModAuthen] = useState<boolean>(false);

  // Handle success message for education approve
  useEffect(() => {
    if (props.successMessage?.[`${props.cardKey}_education_approve`]) {
      setOpenModAuthen(false);
      props.setProp(`successMessage.${props.cardKey}_education_approve`, null);
    }
  }, [props.cardKey, props.setProp, props.successMessage]);

  const findDoctor = useCallback((orderBy: number) => {
    const options: Record<string, any>[] = props.masterOptions?.doctor ?? [];

    const text: string = options.find((data) => data.value === orderBy)?.text || "";

    const doctorName = text.split("(");

    return doctorName[0] || "";
  }, []);

  const handleApproveClick = () => {
    props.setProp("OrderCentralLabSequence.orderId", props.item.id);

    const fullName: string = props.django?.user?.full_name || "";
    const fullNameSplit = fullName.split(" ");
    const currentDoctorName = `${fullNameSplit[0]}${fullNameSplit[1]} ${fullNameSplit[2]}`;

    if (props.selectedEmr?.doctor_name === currentDoctorName && props.item.student_name) {
      props.runSequence({
        sequence: "OrderCentralLab",
        action: "education_approve",
        approved_by_password: "",
        approved_by_username: "",
        cardKey: props.cardKey,
        orderId: props.item.id,
      });

      props.onApprove();
    } else {
      setOpenModAuthen(true);
    }
  };

  const handleApprove = ({ password, username }: any) => {
    props.runSequence({
      sequence: "OrderCentralLab",
      action: "education_approve",
      approved_by_password: password,
      approved_by_username: username,
      cardKey: props.cardKey,
      orderId: props.item.id,
    });

    setOpenModAuthen(false);

    props.onApprove();
  };

  // Don't render careprovider content for cancelled orders
  if (props.item.order_status === "CANCEL") {
    return null;
  }

  // Same doctor ordered and approved
  if (props.item.order_by === props.item.approved_by) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>{props.item.approved_by_name}</div>
    );
  }

  return (
    <div>
      {/* Ordering doctor */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        {findDoctor(props.item.order_by)}
      </div>

      {/* Approval section */}
      {props.item.need_approve && props.item.student_name ? (
        // Needs approval - show approve button
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0px",
          }}
        >
          <ButtonLoadCheck
            setProp={props.setProp}
            id="btn-confirmMedOrder"
            style={{ borderRadius: "10px" }}
            color="green"
            paramKey={`${props.cardKey}_CONFIRM_${props.item.id}`}
            buttonLoadCheck={props.buttonLoadCheck?.[`${props.cardKey}_CONFIRM_${props.item.id}`]}
            onClick={handleApproveClick}
            title={
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{ marginRight: "7px", width: "20px" }}
                  alt="approve"
                  src="/static/images/drugOrder/doctor_approve.png"
                />
                <label>APPROVE</label>
              </div>
            }
          />
        </div>
      ) : (
        props.item.student_name && (
          // Already approved - show approval status
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0px",
              }}
            >
              <img
                style={{ marginRight: "7px", width: "10px 0px" }}
                alt="approved"
                src="/static/images/drugOrder/approve_check.png"
              />
              <label style={{ color: "green" }}>APPROVE</label>
            </div>
            <div
              style={{
                color: "gray",
                display: "flex",
                justifyContent: "center",
              }}
            >
              ตรวจสอบโดย
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "10px 0px",
              }}
            >
              {props.item.approved_by_name}
            </div>
          </div>
        )
      )}

      <ModAuthen
        open={openModAuthen}
        titleColor="blue"
        titleName={intl.formatMessage({ id: "ยืนยันการตรวจสอบ" })}
        onApprove={handleApprove}
        onDeny={() => setOpenModAuthen(false)}
      />

      <ModError
        open={props.errorMessage?.[`${props.cardKey}_education_approve`]}
        titleColor="red"
        onApprove={() => {
          props.setProp(`errorMessage.${props.cardKey}_education_approve`, null);
        }}
        alertText={
          props.errorMessage?.[`${props.cardKey}_education_approve`]?.error?.approved_by?.[0]
        }
      />
    </div>
  );
};

export default SubLabCareProvider;
